<script lang="ts">
  import { lang } from "$store/lang";
  import { localizeHref } from "$lib/services/i18n";
  import Logo from "@component/patterns/Logo.svelte";

  let {
    brand = { name: "Practical", taglineDe: "", taglineEn: "" },
    columns = [] as Array<{
      headingDe?: string;
      headingEn?: string;
      heading?: string;
      links: Array<{
        href: string;
        labelDe?: string;
        labelEn?: string;
        label?: string;
        noLocalize?: boolean;
      }>;
    }>,
    bottom = [] as Array<{
      textDe?: string;
      textEn?: string;
      text?: string;
    }>
  } = $props();

  let currentLang = $state("de");

  $effect(() => {
    currentLang = $lang;
  });
</script>

<footer class="site-footer">
  <div class="container">
    <div class="footer-grid">
      <div class="footer-brand">
        <a href={localizeHref("/", currentLang)} class="logo">
          <Logo /><span class="sr-only">Logo</span>
        </a>
        <p lang="de">{brand.taglineDe}</p>
        <p lang="en">{brand.taglineEn}</p>
      </div>
      {#each columns as col}
        <div class="footer-col">
          <h2 lang="de">{col.headingDe || col.heading}</h2>
          <h2 lang="en">{col.headingEn || col.heading}</h2>
          {#each col.links as link}
            <a href={link.noLocalize ? link.href : localizeHref(link.href, currentLang)}>
              <span lang="de">{link.labelDe || link.label}</span>
              <span lang="en">{link.labelEn || link.label}</span>
            </a>
          {/each}
        </div>
      {/each}
    </div>
    <div class="footer-bottom">
      {#each bottom as line}
        <span lang="de">{line.textDe || line.text}</span>
        <span lang="en">{line.textEn || line.text}</span>
      {/each}
    </div>
  </div>
</footer>

<style>
  .logo {
    width: 100px;
  }
</style>
